<template>
  <div class="lista">
    <b-table striped hover :items="casais" :fields="fields">
      <template slot="esposo" slot-scope="data">
        {{data.item.casal.esposo.nome}}
      </template>

      <template slot="esposa" slot-scope="data">
        {{data.item.casal.esposa.nome}}
      </template>

      <template slot="actions" slot-scope="data">
        <router-link :to="{name: 'editar_casal', params: {id: data.item.key}}">Editar</router-link>
      </template>
    </b-table>
  </div>
</template>
<script>
import { db } from '../../main';

export default {
  name: 'Lista-Casal',
  data() {
    return {
      casais: [],
      fields: [
        {
          key: 'esposo',
          label: 'Nome esposo',
        },
        {
          key: 'esposa',
          label: 'Nome esposa',
        },
        {
          key: 'casamento',
          label: 'Dt. Casamento',
        },
        {
          key: 'actions',
          label: '',
        },
      ],
    };
  },
  created() {
    db.collection('casais').get().then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        this.casais.push({ key: doc.id, casal: doc.data() });
        this.$store.commit('setLoading', false);
      });
    });
  },
};
</script>
